/**
 * @generated SignedSource<<26b045e15e80b0cdfb8fd6a415c8013b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ShoppingPreview_testOrder_Mutation$variables = {
  compositionDocID?: string | null;
};
export type ShoppingPreview_testOrder_Mutation$data = {
  readonly createTestOrder: {
    readonly orderID: number;
  };
};
export type ShoppingPreview_testOrder_Mutation = {
  response: ShoppingPreview_testOrder_Mutation$data;
  variables: ShoppingPreview_testOrder_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "compositionDocID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "compositionDocID",
    "variableName": "compositionDocID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShoppingPreview_testOrder_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "createTestOrder",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ShoppingPreview_testOrder_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "createTestOrder",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86251ea23f1de1bbc969d94a65abeae1",
    "id": null,
    "metadata": {},
    "name": "ShoppingPreview_testOrder_Mutation",
    "operationKind": "mutation",
    "text": "mutation ShoppingPreview_testOrder_Mutation(\n  $compositionDocID: String\n) {\n  createTestOrder(compositionDocID: $compositionDocID) {\n    orderID\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "87f3d371dd3fad46b7b2634bf5106fc4";

export default node;
